import { render } from "./sponsors.vue?vue&type=template&id=1bebe0b4&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=1bebe0b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bebe0b4"

export default script